import { supabase } from '@/integrations/supabase/client';
import { AuditAction } from '@/types/types';
import { getUserGymId } from '@/utils/gymAuth';
import { apiBaseUrl } from '@/utils/config';

export async function logUserActivity(
  action: AuditAction,
  target: string,
  targetUserId?: string
) {
  const gymId = getUserGymId();
  
  if (!gymId) {
    console.warn('⚠️ Cannot log activity: user has no gym selected');
    return;
  }

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      console.warn('⚠️ Cannot log activity: no active session');
      return;
    }

    const response = await fetch(`${apiBaseUrl}/functions/v1/log-activity`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        action,
        target,
        gym_id: gymId,
        target_user_id: targetUserId,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      console.error('❌ Error logging activity:', error);
    }
  } catch (error) {
    console.error('❌ Error logging activity:', error);
  }
}
